import React, { memo } from 'react';
import { Tabs } from '@mui/material';

import { ListMinifiedIcon, ChartIcon } from '../../../icons';
import { PAGE_START, SECTION_FULL_PAGE } from '../../../../constants/routes';
import StyledTab from '../../../IconTab';

const DrawerToggle = ({ value, onChange }) => (
  <Tabs
    TabIndicatorProps={{
      hidden: true,
    }}
    value={value}
    onChange={onChange}
    variant="fullWidth"
  >
    <StyledTab
      data-testid="list-minified"
      icon={<ListMinifiedIcon />}
      value={PAGE_START}
    />
    <StyledTab
      data-testid="chart"
      icon={<ChartIcon />}
      value={SECTION_FULL_PAGE}
    />
  </Tabs>
);

export default memo(DrawerToggle);
